import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchAdminListingShift = ({ listingID, shiftID }: { listingID: number; shiftID: number }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: `/admin/listings/${listingID}/shifts/${shiftID}` })
    handleCall(req, resolve, reject, true)
  })
